import React, { useEffect, useMemo, useState } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { Formik, useFormikContext } from 'formik';
import * as yup from 'yup';
import ArrowLeft from 'assets/icons/ic-arrow-left.svg';
import './Assessment.scss';
import { Tab, Tabs } from 'react-bootstrap';
import { TabContent } from 'components/common/TabContent';
import { getAssessment, postAssessment } from 'store/assessmentSingle/actions';
import { useDispatch, useSelector } from 'react-redux';
import { IAppState } from 'store';
import { IAssessmentSingleState } from 'store/assessmentSingle/types';
import { configureValidation, DISABLED_ASSESSMENT_STATUS_FLAG } from './config';
import TableLoader from 'components/TableLoader';
import { CompleteAssessment } from 'components/CompleteAssessment';
import { SaveAssessmentModal } from '../../components/SaveAssessmentModal';
import { ROUTES } from '../../config/routes';
import { getApiAssessment } from '../../store/assessment/actions';
import { useTranslation } from 'react-i18next';
import { translateText } from 'utils/helpers/useTranslation';
import { CONDITIONS } from 'utils/helpers/enum';
import { checkAllConditionsFollow } from 'utils/helpers/useCondition';
import DownloadReportButton from 'components/DownloadReportButton';
import SavePopup from 'components/SavePopup';

interface IInitialValues {
  [key: string]: string | object;
}

interface IValidationScheme {
  [key: string]: any;
}
interface IProps {
  setDoctId?: React.Dispatch<React.SetStateAction<any>>;
}
const Assessment = () => {
  const { uid } = useParams<{ uid: string }>();
  const dispatch = useDispatch();
  const history = useHistory();
  const [changedFieldsId, setChangedFieldsId] = useState([]);
  const [currentTab, setCurrentTab] = useState();
  const [currentId, setCurrentId] = useState();

  const [formikVal, setFormikVal] = useState();
  const [newDataToPost, setNewDataToPost] = useState([]);
  const [shouldAvtoSave, setShouldAvtoSave] = useState(false);
  const [userHandleSaveData, setUserHandleSaveData] = useState(false);

  const [exitModalOpen, setExitModalOpen] = useState(false);
  const [isHaveErrors, SetIsHaveErrors] = useState(false);
  const { t } = useTranslation();

  const [currentAssesmentID, setCurrentAssesmentID] = useState(0);
  const [saveBeforeExitPopupOpen, setSaveBeforeExitPopupOpen] = useState(false);


  const { data, isLoading, error } = useSelector<
    IAppState,
    IAssessmentSingleState
  >(state => state.singleAssessment);
  const originalData = useSelector((state: IAppState) => state.singleAssessment.originalData);
  const [newData, setNewData] = useState(data);

  const [key, setKey] = useState('');
  const [packageKey, setPackageKey] = useState('');

  useEffect(() => {
    if (data.length > 1) {
      const firstVisibleTab = data?.find(
        el => el.Template.TemplatePageType !== 0,
      );
      setCurrentAssesmentID(data[0]?.ID)
      if (!packageKey) {
        setPackageKey(firstVisibleTab?.Template.Name);
      }
    } else {
      const firstVisibleTab = data?.[0]?.Pages.find(
        el => el.Template.TemplatePageType !== 0,
      );
      setCurrentAssesmentID(data[0]?.ID)
      if (key === '' || !key) {
        setKey(firstVisibleTab?.Template.Name);
      }
    }
  }, [data]);

  useEffect(() => {
    setKey(undefined);
  }, [packageKey]);

  const [initialValues, validSchema] = useMemo(() => {
    const initial: IInitialValues = {};
    const validation: IValidationScheme = {};
    data.forEach(ass => {
      ass?.Pages.forEach(page => {
        page.Fields.forEach(field => {
          if (field.Template.FieldType.Name === 'Grid') {
            const arrayOfFields = [];
            field.GridChildren.forEach(fieldArray => {
              const fieldsObject = {};
              fieldArray.forEach(f => {
                fieldsObject[f.Template.Name] = f.Value;
              });
              arrayOfFields.push(fieldsObject);
            });
            initial[field.Guid] = arrayOfFields;
          } else {
            initial[field.Guid] = field.Value || '';
          }
        });
      });
    });
    return [initial, validation];
  }, [data, newData]);

  useEffect(() => {
    dispatch(getAssessment(uid));
  }, [dispatch, uid]);

  useEffect(() => {
    setNewData(data);
  }, [data]);



  const onGoBack = (isFormTouched: any) => {
    if (data?.[0]?.StatusFlag === 2 || data?.[0]?.StatusFlag === 5) {
      history.goBack();
      return null;
    }
    if (!!Object.keys(isFormTouched).length) {
      setExitModalOpen(true);
    } else {
      history.goBack();
    }
  };

  const onModalAgree = async () => {
    await dispatch(getApiAssessment());
    setExitModalOpen(false);
    history.goBack();
  };

  const onModalCancel = () => {
    setExitModalOpen(false);
  };

  const haveErrorsHandler = () => {
    SetIsHaveErrors(true);
  };



  const saveFieldsData = (pData, values, changedFieldsId) => {
    const dataToPost = [];

    const processGridField = f => {
      const originalGridField = originalData?.[0]?.Pages?.find(originalPage => 
        originalPage.ID === pData.ID
      )?.Fields?.find(originalField => 
        originalField.Template.ID === f.Template.ID
      );
      
      f.GridChildren = f.GridChildren.map((row, rowIndex) => 
        row.map((field, fieldIndex) => {
          const originalRow = originalGridField?.GridChildren?.[rowIndex];
          const originalField = originalRow?.[fieldIndex];
          
          if (originalField && originalField.ID) {
            return { ...field, ID: originalField.ID };
          }
          
          return { ...field };
        })
      );
      
      if (f.Template.Validator?.MaxRows && f.Template.Validator.MaxRows > f.GridChildren.length) {
        const lastRow = f.GridChildren[f.GridChildren.length - 1];
        if (lastRow) {
          const objEmpty = [];
          
          let maxId = 0;
          f.GridChildren.forEach(row => {
            row.forEach(field => {
              if (field.ID > maxId) {
                maxId = field.ID;
              }
            });
          });
          
          let newId = maxId + 1;

          lastRow.forEach(item => {
            const newObj = {
              ...item,
              ID: newId++,
              Value: null,
              GridRow: item.GridRow + 1,
            };
            objEmpty.push(newObj);
          });

          f.GridChildren.push(objEmpty);
        }
      }

      f.GridChildren.forEach(fieldsArray => {
        fieldsArray.forEach(field => {
          if (values[f.Guid] &&
              values[f.Guid][field.GridRow] &&
              values[f.Guid][field.GridRow][field.Template.Name] !== undefined) {
            field.Value = values[f.Guid][field.GridRow][field.Template.Name] as string | null;
          }
        });
      });

      if (changedFieldsId.includes(f.Guid)) {
        dataToPost.push({ ...f });
      }
    };

    const processField = f => {
      if (f.Template.FieldType?.Name === 'Grid') {
        processGridField(f);
      } else {
        if (changedFieldsId.includes(f.Guid)) {
          dataToPost.push({
            ...f,
            Value: values[f.Guid] as string,
          });
        }
      }
    };

    if (data.length > 0) {
      data.forEach(pData =>
        pData?.Pages.forEach(p => p.Fields.forEach(processField)),
      );
    } else {
      pData?.forEach(p => p?.Fields.forEach(processField));
    }
    
    setNewDataToPost(dataToPost);
  };

  useEffect(() => {
    if (changedFieldsId.length > 0)
      saveFieldsData(currentTab, formikVal, changedFieldsId);
  }, [changedFieldsId, formikVal, currentTab]);

  useEffect(() => {
    let timeoutId;
    if (changedFieldsId.length > 0 && !shouldAvtoSave) {
      timeoutId = setTimeout(() => setShouldAvtoSave(true), 60000);
    }
    if (changedFieldsId.length === 0) {
      clearTimeout(timeoutId);
    }
    
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [changedFieldsId, shouldAvtoSave]);

  const createFullPayload = (values, pData) => {
    const dataToPost = [];
    
    const processGridField = (f, p) => {
      const originalGridField = originalData?.[0]?.Pages?.find(originalPage => 
        originalPage.ID === p.ID
      )?.Fields?.find(originalField => 
        originalField.Template.ID === f.Template.ID
      );
      
      const gridField = { ...f };
      
      gridField.GridChildren = f.GridChildren.map((row, rowIndex) => 
        row.map((field, fieldIndex) => {
          const originalRow = originalGridField?.GridChildren?.[rowIndex];
          const originalField = originalRow?.[fieldIndex];
          
          if (originalField && originalField.ID) {
            return { ...field, ID: originalField.ID };
          }
          
          return { ...field };
        })
      );

      if (f.Template.Validator?.MaxRows && f.Template.Validator.MaxRows > f.GridChildren.length) {
        const lastRow = f.GridChildren[f.GridChildren.length - 1];
        if (lastRow && lastRow.length > 0) {
          const objEmpty = [];
          
          let maxId = 0;
          f.GridChildren.forEach(row => {
            row.forEach(field => {
              if (field.ID > maxId) {
                maxId = field.ID;
              }
            });
          });
          
          let newId = maxId + 1;

          lastRow.forEach(item => {
            const newObj = {
              ...item,
              ID: newId++,
              Value: null,
              GridRow: item.GridRow + 1,
            };
            objEmpty.push(newObj);
          });

          gridField.GridChildren.push(objEmpty);
        }
      }

      if (changedFieldsId.includes(f.Guid)) {
        
        gridField.GridChildren.forEach(fieldsArray => {
          fieldsArray.forEach(field => {
            if (values[f.Guid] &&
                values[f.Guid][field.GridRow] &&
                values[f.Guid][field.GridRow][field.Template.Name] !== undefined) {
              field.Value = values[f.Guid][field.GridRow][field.Template.Name] as string | null;
            }
          });
        });

        const cleanGridField = {
          ID: gridField.ID,
          Guid: gridField.Guid,
          GridRow: gridField.GridRow,
          GridColumn: gridField.GridColumn,
          Value: gridField.Value,
          Template: {
            ID: gridField.Template.ID,
            Name: gridField.Template.Name,
            DisplayName: gridField.Template.DisplayName,
            Required: gridField.Template.Required,
            Order: gridField.Template.Order,
            HelpText: gridField.Template.HelpText,
            GridChild: gridField.Template.GridChild,
            FieldAlias: gridField.Template.FieldAlias,
            FieldType_ID: gridField.Template.FieldType_ID,
            FieldType: {
              ID: gridField.Template.FieldType.ID,
              Name: gridField.Template.FieldType.Name,
              Discriminator: gridField.Template.FieldType.Discriminator
            },
            Parameters_ID: gridField.Template.Parameters_ID,
            Parameters: gridField.Template.Parameters,
            Validator_ID: gridField.Template.Validator_ID,
            Validator: gridField.Template.Validator,
            DisplayConditions: gridField.Template.DisplayConditions,
            OriginalSize: gridField.Template.OriginalSize,
            OriginalWidth: gridField.Template.OriginalWidth,
            OriginalHeight: gridField.Template.OriginalHeight,
            MaintainAspectRatio: gridField.Template.MaintainAspectRatio,
            InitiallyVisibleOnLoad: gridField.Template.InitiallyVisibleOnLoad,
            VisibleExternally: gridField.Template.VisibleExternally,
            Archived: gridField.Template.Archived,
            ImageOnly: gridField.Template.ImageOnly,
            HasImage: gridField.Template.HasImage
          },
          GridChildren: gridField.GridChildren.map(row => 
            row.map(field => ({
              ID: field.ID,
              Guid: field.Guid,
              GridRow: field.GridRow,
              GridColumn: field.GridColumn,
              Value: field.Value,
              Template: {
                ID: field.Template.ID,
                Name: field.Template.Name,
                DisplayName: field.Template.DisplayName,
                Required: field.Template.Required,
                Order: field.Template.Order,
                HelpText: field.Template.HelpText,
                GridChild: field.Template.GridChild,
                FieldAlias: field.Template.FieldAlias,
                FieldType_ID: field.Template.FieldType_ID,
                FieldType: {
                  ID: field.Template.FieldType.ID,
                  Name: field.Template.FieldType.Name,
                  Discriminator: field.Template.FieldType.Discriminator
                },
                Parameters_ID: field.Template.Parameters_ID,
                Parameters: field.Template.Parameters,
                Validator_ID: field.Template.Validator_ID,
                Validator: field.Template.Validator,
                DisplayConditions: field.Template.DisplayConditions,
                OriginalSize: field.Template.OriginalSize,
                OriginalWidth: field.Template.OriginalWidth,
                OriginalHeight: field.Template.OriginalHeight,
                MaintainAspectRatio: field.Template.MaintainAspectRatio,
                InitiallyVisibleOnLoad: field.Template.InitiallyVisibleOnLoad,
                VisibleExternally: field.Template.VisibleExternally,
                Archived: field.Template.Archived,
                ImageOnly: field.Template.ImageOnly,
                HasImage: field.Template.HasImage
              },
              GridChildren: field.GridChildren || [],
              Invalid: field.Invalid
            }))
          ),
          Invalid: gridField.Invalid
        };
        
        dataToPost.push(cleanGridField);
      }
    };

    const processField = (f, p) => {
      if (f.Template.FieldType?.Name === 'Grid') {
        processGridField(f, p);
      } else {
        if (changedFieldsId.includes(f.Guid)) {
          dataToPost.push({
            ...f,
            Value: values[f.Guid] as string,
          });
        }
      }
    };

    if (data.length > 0) {
      data.forEach(pData =>
        pData?.Pages.forEach(p => p.Fields.forEach(f => processField(f, p))),
      );
    } else {
      pData?.forEach(p => p?.Fields.forEach(f => processField(f, p)));
    }

    return dataToPost;
  };

  const postAndGetAss = async (): Promise<void> => {
    try {
      const fullPayload = createFullPayload(formikVal, currentTab);
      await dispatch(postAssessment(fullPayload, true));
      setChangedFieldsId([]);
      setNewDataToPost([]);
      setShouldAvtoSave(false);
    } catch (error) {
      console.error('Autosave error:', error);
      setShouldAvtoSave(false);
    }
  };
  useEffect(() => {
    if (shouldAvtoSave && changedFieldsId.length > 0) {
      postAndGetAss().catch(error => {
        console.error('Autosave error in useEffect:', error);
      });
    }
  }, [shouldAvtoSave, changedFieldsId]);



  useEffect(() => {
    const form = document.getElementById('main-form123');
    form?.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
      }
    });
    if (changedFieldsId.length === 0) {
      setShouldAvtoSave(false);
    }
  }, [changedFieldsId]);

  const validateForm = (values: any) => {
    const errors: any = {};
    
    const currentDataWithValues = data.map(ass => ({
      ...ass,
      Pages: ass.Pages.map(page => ({
        ...page,
        Fields: page.Fields.map(field => ({
          ...field,
          Value: values[field.Guid] || field.Value
        }))
      }))
    }));
    
    data.forEach(ass => {
      ass?.Pages.forEach(page => {
        page.Fields.forEach(field => {
          const visible = field.Template.InitiallyVisibleOnLoad;
          const noDisplayConditions =
            !field.Template.DisplayConditions ||
            field.Template.DisplayConditions.length === 0;
          const conditionToShow =
            visible ||
            (!visible && noDisplayConditions) ||
            (!visible &&
              !noDisplayConditions &&
              checkAllConditionsFollow(field, currentDataWithValues));
          
          if (conditionToShow) {
            if (field.Template.FieldType?.Name === 'Grid') {
              const gridData = values[field.Guid];
              if (gridData && Array.isArray(gridData)) {
                gridData.forEach((row, rowIndex) => {
                  if (row && typeof row === 'object') {
                    Object.keys(row).forEach(fieldName => {
                      const gridField = field.GridChildren.flat().find(f => f.Template.Name === fieldName);
                      if (gridField && gridField.Template.Required) {
                        const fieldValue = row[fieldName];
                        if (!fieldValue || fieldValue === '') {
                          errors[`${field.Guid}.${rowIndex}.${fieldName}`] = 'This field is required';
                        }
                      }
                    });
                  }
                });
              }
            } else {
              const fieldValue = values[field.Guid];
              const validator = field.Template.Validator;
              
              if (field.Template.Required) {
                if (!fieldValue || fieldValue === '') {
                  errors[field.Guid] = 'This field is required';
                }
              }
              
              if (fieldValue && fieldValue !== '' && validator) {
                const discriminator = validator.Discriminator;
                
                switch (discriminator) {
                  case 'NumericValidator':
                    const numValue = parseFloat(fieldValue);
                    if (isNaN(numValue)) {
                      errors[field.Guid] = 'Must be a valid number';
                    } else {
                      if (validator.Minimum !== undefined && numValue < validator.Minimum) {
                        errors[field.Guid] = `Minimum value is ${validator.Minimum}`;
                      }
                      if (validator.Maximum !== undefined && numValue > validator.Maximum) {
                        errors[field.Guid] = `Maximum value is ${validator.Maximum}`;
                      }
                      if (validator.IntegerOnly && !Number.isInteger(numValue)) {
                        errors[field.Guid] = 'Must be a whole number';
                      }
                    }
                    break;
                    
                  case 'TextValidator':
                    if (validator.MinimumLength !== undefined && fieldValue.length < validator.MinimumLength) {
                      errors[field.Guid] = `Minimum length is ${validator.MinimumLength} characters`;
                    }
                    if (validator.MaximumLength !== undefined && fieldValue.length > validator.MaximumLength) {
                      errors[field.Guid] = `Maximum length is ${validator.MaximumLength} characters`;
                    }
                    break;
                    
                  case 'DateTimeValidator':
                    const dateValue = new Date(fieldValue);
                    if (isNaN(dateValue.getTime())) {
                      errors[field.Guid] = 'Must be a valid date';
                    } else {
                      if (validator.MinimumDate && dateValue < new Date(validator.MinimumDate)) {
                        errors[field.Guid] = `Date must be after ${validator.MinimumDate}`;
                      }
                      if (validator.MaximumDate && dateValue > new Date(validator.MaximumDate)) {
                        errors[field.Guid] = `Date must be before ${validator.MaximumDate}`;
                      }
                    }
                    break;
                    
                  case 'MultiSelectionFieldValidator':
                    if (Array.isArray(fieldValue)) {
                      if (validator.MinRows !== undefined && fieldValue.length < validator.MinRows) {
                        errors[field.Guid] = `Minimum ${validator.MinRows} selections required`;
                      }
                      if (validator.MaxRows !== undefined && fieldValue.length > validator.MaxRows) {
                        errors[field.Guid] = `Maximum ${validator.MaxRows} selections allowed`;
                      }
                    }
                    break;
                }
              }
            }
          }
        });
      });
    });
    
    return errors;
  };

  return (
    <>
      <div className="page-content">
        <div
          className={
            isHaveErrors
              ? 'container-custom container assessment-container invalid'
              : 'container-custom container assessment-container'
          }
        >
          <div className="row">
            <div className="col-12">
              {isLoading ? (
                <TableLoader />
              ) : error ? (
                <p>sorry we have some troubles, reload the page please</p>
              ) : (
                <>
                  <div className="assessment-header">
                    <h2
                      className="assessment-name"
                      onClick={() => {
                        setUserHandleSaveData(true);
                        setShouldAvtoSave(false);
                        setSaveBeforeExitPopupOpen(true);
                      }}
                    >
                      <button className="assessment-back">
                        <img src={ArrowLeft} alt="arrow image" />
                      </button>

                      {data.length > 0 && data[0].Template.Name}
                    </h2>
                    <div className="assessment-buttons">
                      {/* <CompleteAssessment
                              assessmentsId={data?.map(ass => ass.ID)}
                              isHaveErrors={haveErrorsHandler}
                            /> */}
                    </div>
                  </div>
                  <Formik
                    initialValues={initialValues}
                    validate={validateForm}
                    // validateOnChange={false}
                    // validateOnBlur={false}
                    onSubmit={() => console.log('')}
                  >
                    {formik => (
                      <form
                        id="main-form123"
                        onSubmit={e => {
                          e.preventDefault();
                          formik.handleSubmit(e);
                        }}
                      >
                        <div className="tabs-wrapper">
                          {data?.length > 1 ? (
                            <Tabs
                              onSelect={k => setPackageKey(k)}
                              activeKey={packageKey}
                              className="nav nav-tabs primary-tabs package-sticky-header-assesments"
                            >
                              {data?.map(
                                (ass, assesmentIndex) => {
                                  
                                  return (
                                    // ass.Template.TemplatePageType == 0 && (
                                    <Tab
                                      onEnter={() => {
                                        setCurrentAssesmentID(ass.ID);
                                        return null;
                                      }}
                                      className="nav-item nav-link"
                                      title={translateText(
                                        ass.Template.Name,
                                        data,
                                      )}
                                      eventKey={ass.Template.Name}
                                      key={ass.ID}
                                    >
                                      <div className="inner-tabs-wrapper">
                                        <Tabs
                                          className="nav nav-tabs package-sticky-tabs"
                                          activeKey={key}
                                          onSelect={k => setKey(k)}
                                        >
                                          {ass?.Pages.map((p, i) => {
                                            const noDisplayConditions =
                                              !p.Template.DisplayConditions ||
                                              p.Template.DisplayConditions.length < 1;
                                            const conditionToShow =
                                              noDisplayConditions ||
                                              (!noDisplayConditions &&
                                                checkAllConditionsFollow(
                                                  p,
                                                  newData &&
                                                    newData[assesmentIndex],
                                                ));

                                            return (
                                              p.Template.TemplatePageType !==
                                                0 &&
                                              conditionToShow && (
                                                <Tab
                                                  className="nav-item nav-link"
                                                  title={p.Template.Name}
                                                  eventKey={p.Template.Name}
                                                  key={p.ID}
                                                >
                                                  <TabContent
                                                    newDataToPost={
                                                      newDataToPost
                                                    }
                                                    setUserHandleSaveData={
                                                      setUserHandleSaveData
                                                    }
                                                    newData={
                                                      newData &&
                                                      newData[assesmentIndex]
                                                    }
                                                    setFormikVal={setFormikVal}
                                                    setCurrentTab={
                                                      setCurrentTab
                                                    }
                                                    setCurrentId={setCurrentId}
                                                    changedFieldsId={
                                                      changedFieldsId
                                                    }
                                                    setChangedFieldsId={
                                                      setChangedFieldsId
                                                    }
                                                    translations={
                                                      data?.[0]?.Template
                                                        .Translations
                                                    }
                                                    data={p}
                                                    fieldsDisabled={
                                                      ass.StatusFlag ===
                                                      DISABLED_ASSESSMENT_STATUS_FLAG
                                                    }
                                                    pageNum={i}
                                                    assId={ass.ID}
                                                  >
                                                    <CompleteAssessment
                                                      userHandleSaveData={
                                                        userHandleSaveData
                                                      }
                                                      setUserHandleSaveData={
                                                        setUserHandleSaveData
                                                      }
                                                      changedFieldsId={
                                                        changedFieldsId
                                                      }
                                                      setChangedFieldsId={
                                                        setChangedFieldsId
                                                      }
                                                      assessmentsId={
                                                        data?.[0].ID
                                                      }
                                                      isHaveErrors={
                                                        haveErrorsHandler
                                                      }
                                                      dataP={p}
                                                    />
                                                  </TabContent>
                                                </Tab>
                                              )
                                            );
                                          })}
                                        </Tabs>
                                        <DownloadReportButton
                                          assesmentID={ass.ID}
                                        />
                                      </div>
                                    </Tab>
                                  );
                                },
                                // ),
                              )}
                            </Tabs>
                          ) : (
                            <Tabs
                              className="nav nav-tabs single-sticky-tabs"
                              activeKey={key}
                              onSelect={k => setKey(k)}
                            >
                              {data?.[0]?.Pages.map((p, i) => {
                                const noDisplayConditions =
                                  p.Template.DisplayConditions.length < 1 ||
                                  p.Template.DisplayConditions === undefined ||
                                  p.Template.DisplayConditions === null;
                                const conditionToShow =
                                  noDisplayConditions ||
                                  (!noDisplayConditions &&
                                    checkAllConditionsFollow(p, newData));

                                if (p.Template.TemplatePageType !== 0) {
                                  if (conditionToShow) {
                                    return (
                                      <Tab
                                      onEnter={() => {
                                        setCurrentAssesmentID(data?.[0]?.ID);
                                        return null;
                                      }}
                                        className="nav-item nav-link"
                                        title={translateText(
                                          p.Template.Name,
                                          data,
                                        )}
                                        eventKey={p.Template.Name}
                                        key={p.ID}
                                      >
                                        {/* <SavePopup 
                                                   data={newData && newData[0]}
                                                    isOpen={saveBeforeExitPopupOpen} 
                                                    setIsOpen={setSaveBeforeExitPopupOpen} 
                                                    changedFieldsId={changedFieldsId} 
                                                    setChangedFieldsId={setChangedFieldsId} 
                                                    setUserHandleSaveData={setUserHandleSaveData} 
                                                  />  */}
                                        <TabContent
                                          setCurrentId={setCurrentId}
                                          setUserHandleSaveData={
                                            setUserHandleSaveData
                                          }
                                          setFormikVal={setFormikVal}
                                          setCurrentTab={setCurrentTab}
                                          changedFieldsId={changedFieldsId}
                                          setChangedFieldsId={
                                            setChangedFieldsId
                                          }
                                          initialValues={initialValues}
                                          translations={
                                            data?.[0]?.Template.Translations
                                          }
                                          data={p}
                                          newData={newData && newData[0]}
                                          setNewData={setNewData}
                                          fieldsDisabled={
                                            data?.[0].StatusFlag ===
                                            DISABLED_ASSESSMENT_STATUS_FLAG
                                          }
                                          pageNum={i}
                                          assId={data?.[0].ID}
                                        >
                                          <CompleteAssessment
                                            userHandleSaveData={
                                              userHandleSaveData
                                            }
                                            setUserHandleSaveData={
                                              setUserHandleSaveData
                                            }
                                            changedFieldsId={changedFieldsId}
                                            setChangedFieldsId={
                                              setChangedFieldsId
                                            }
                                            assessmentsId={data?.[0].ID}
                                            isHaveErrors={haveErrorsHandler}
                                            dataP={p}
                                          />
                                        </TabContent>
                                        <DownloadReportButton
                                          assesmentID={data?.[0]?.ID}
                                        />
                                      </Tab>
                                    );
                                  }
                                }
                              })}
                            </Tabs>
                          )}
                        </div>
                        <SavePopup
                          data={newData.find(
                            assesment => assesment.ID === currentAssesmentID,
                          )}
                          isOpen={saveBeforeExitPopupOpen}
                          setIsOpen={setSaveBeforeExitPopupOpen}
                          changedFieldsId={changedFieldsId}
                          setChangedFieldsId={setChangedFieldsId}
                          setUserHandleSaveData={setUserHandleSaveData}
                        />
                      </form>
                    )}
                  </Formik>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <SaveAssessmentModal
        onSave={onModalAgree}
        onExit={onModalCancel}
        isOpen={exitModalOpen}
        text={t('AP_sav?')}
        primaryButtonText={t('AP_agree')}
        cancelButtonText={t('AP_cancel')}
      /> */}
    </>
  );
};

export { Assessment };